import { iconRemove } from "assets";
import DatePicker from "components/app/function/DatePicker";
import SearchBarStaff from "components/app/search-bar/SearchBarStaff";

import { AlignJustify, CircleCheck, CircleOff, CircleStop, CreditCard, Grid2x2, Loader, Plus, PrinterCheck, Trash2 } from "lucide-react";
import HoverCardDetail from "pages/hover-card-detail/HoverCardDetail";
import { useAppSelector } from "store/store";
import { Popover, PopoverContent, PopoverTrigger } from "components/ui/popover";
import appStore from "store/appStore";
import { setIndexs } from "store/header";
import { useDispatch } from "react-redux";

const StaffNavbar = ({
  selectProducts,
  selectedProductIds,
  allIds,
  setOpenPopoverIndex,
  setSelectProducts,
  isAllSelected,
  handleToggleSelectAll,
  setSelectedProductIds,
  handlePrint,
  loadingPrint,
  setSearchTextInput,
  view,
  changeView,
  setIsCreateStaff,
  setShopEmployeeDetail,
  setLoadingFetchDataShopEmployeeDetail,
  dataTimesheets,
  handleClick,
  submitDeleteShopEmployee,
  submitUndoDeleteShopEmployee,
  dobStaff,
  setDobStaff,
}: any) => {
  const { btnToggle } = useAppSelector((state) => state.header);
  const { showDialogConfirm } = appStore();
  const dispatch = useDispatch();

  return (
    <nav className="border-gray-200 pt-5 flex items-center justify-between">
      <div className="flex items-center gap-3">
        {selectProducts && (
          <div className="flex items-center justify-center px-5 py-2 bg-blue-500 rounded-full text-white">
            Employee Selected {selectedProductIds.length} / {allIds.length}
          </div>
        )}
        <>
          {!selectProducts ? (
            <>
              <HoverCardDetail
                title="Create New Staff "
                description={
                  <>
                    <p className="mb-2 font-medium text-sm dark:text-white">Add new staff member to your team by entering their personal and job details.</p>
                    <ul className="list-disc pl-5 text-sm dark:text-gray-300 space-y-1">
                      <li>Include contact information, role, and department.</li>
                      <li>Set permissions and access levels if applicable.</li>
                      <li>Ensures staff are properly tracked and managed in the system.</li>
                    </ul>
                  </>
                }
              >
                <label
                  onClick={() => {
                    setIsCreateStaff(true);
                    setOpenPopoverIndex(1);
                    setShopEmployeeDetail(null);
                    setLoadingFetchDataShopEmployeeDetail(false);
                  }}
                  htmlFor=""
                  className={`hover:border-3 transition-all duration-300 font-semibold rounded-full cursor-pointer lg:w-10 lg:h-10 md:w-10 md:h-10 w-8 h-8 flex items-center justify-center text-md border border-gray-300 
                        `}
                >
                  <Plus className="font-semibold text-xl" />
                </label>
              </HoverCardDetail>
            </>
          ) : (
            <>
              {selectedProductIds.length > 0 && !btnToggle ? (
                <>
                  <Popover>
                    <PopoverTrigger asChild>
                      <label className=" font-semibold cursor-pointer rounded-full lg:w-10 lg:h-10 md:w-10 md:h-10 w-8 h-8 flex items-center justify-center text-md border border-gray-300">
                        <AlignJustify />
                      </label>
                    </PopoverTrigger>
                    <PopoverContent className="w-80 relative">
                      {dataTimesheets?.map((item: any, index: number) => {
                        return (
                          <HoverCardDetail key={index} title={item.title} description={item.description}>
                            <div
                              key={index}
                              className="gap-3 group  flex items-center px-3 py-2 rounded-md hover:bg-accent cursor-pointer"
                              onClick={() => {
                                handleClick(item.title);
                              }}
                            >
                              <span className="group-hover:scale-110 transition-all duration-300">{item.icon}</span>

                              <div className="flex flex-col ">
                                <span className="font-medium leading-none lg:text-md md:text-sm text-[13px]">{item.title}</span>
                                <span className="text-sm text-muted-foreground line-clamp-1">{item.label} </span>
                              </div>
                            </div>
                          </HoverCardDetail>
                        );
                      })}
                    </PopoverContent>
                  </Popover>
                  <HoverCardDetail
                    title="Delete Staff "
                    description={
                      <>
                        <p className="mb-2 font-medium text-sm dark:text-white">
                          Move the staff record to Trash. The employee will no longer appear in active lists but can be recovered.
                        </p>
                        <ul className="list-disc pl-5 text-sm dark:text-gray-300 space-y-1">
                          <li>Soft delete allows for accidental removals to be undone.</li>
                          <li>Trash keeps records safe until permanent deletion.</li>
                          <li>Useful for managing staff turnover or temporary removals.</li>
                        </ul>
                      </>
                    }
                  >
                    <label
                      onClick={() =>
                        showDialogConfirm({
                          titileButtonSubmit: "Yes, Delete",
                          titileButtonCancel: "No, Cancel",
                          title: "Delete",
                          message: "Do you want to delete?",
                          onSubmit() {
                            submitDeleteShopEmployee();
                          },
                        })
                      }
                      className="group transition-all duration-300 font-semibold cursor-pointer rounded-full 
                                                             lg:w-10 lg:h-10 md:w-10 md:h-10 w-8 h-8 flex items-center justify-center text-md border border-gray-300"
                    >
                      <Trash2 className=" transition-colors duration-300" />
                    </label>
                  </HoverCardDetail>
                </>
              ) : (
                btnToggle && (
                  <>
                    <HoverCardDetail
                      title="Restore Staff "
                      description={
                        <>
                          <p className="mb-2 font-medium text-sm dark:text-white ">Restore an staff record from Trash back to the active staff list.</p>
                          <ul className="list-disc pl-5 text-sm dark:text-gray-300 space-y-1">
                            <li>Recovers all staff details and permissions.</li>
                            <li>Useful if deletion was accidental or temporary.</li>
                            <li>Immediately makes the staff visible in all relevant areas.</li>
                          </ul>
                        </>
                      }
                    >
                      <label
                        onClick={() =>
                          showDialogConfirm({
                            titileButtonCancel: "No, Cancel",
                            title: "Recover",
                            message: "Do you want to recover?",
                            onSubmit() {
                              submitUndoDeleteShopEmployee();
                            },
                          })
                        }
                        className="group  hover:border-3  transition-all duration-300 font-semibold cursor-pointer rounded-full 
                                                             lg:w-10 lg:h-10 md:w-10 md:h-10 w-8 h-8 flex items-center justify-center text-md border border-gray-300"
                      >
                        <i className="fa-solid fa-trash-can-arrow-up text-xl   transition-colors duration-300"></i>
                      </label>
                    </HoverCardDetail>
                    <HoverCardDetail
                      title="Permanently Deleted"
                      description={
                        <>
                          <p className="mb-2 font-medium text-sm dark:text-white ">Permanently delete the staff record from the system. This action cannot be undone.</p>
                          <ul className="list-disc pl-5 text-sm dark:text-gray-300 space-y-1">
                            <li>Removes all data associated with the staff.</li>
                            <li>The staff will no longer be available in any reports or listings.</li>
                            <li>Make sure the staff is no longer required before deleting permanently.</li>
                          </ul>
                          {/* <p className="text-xs text-red-500 mt-1">⚠️ This is irreversible.</p> */}
                        </>
                      }
                    >
                      <label
                        onClick={() =>
                          showDialogConfirm({
                            titileButtonCancel: "No, Cancel",
                            title: "Permanance Delete",
                            message: "Do you want to permanance delete?",
                            onSubmit() {
                              submitDeleteShopEmployee();
                            },
                          })
                        }
                        className="group  hover:border-3  transition-all duration-300 font-semibold cursor-pointer rounded-full 
                                                             lg:w-10 lg:h-10 md:w-10 md:h-10 w-8 h-8 flex items-center justify-center text-md border border-gray-300"
                      >
                        <img src={iconRemove} className="w-7 h-7 transition duration-300 filter  group-hover:hue-rotate-[330deg] group-hover:saturate-[5] dark:invert" alt="icon" />
                      </label>
                    </HoverCardDetail>
                  </>
                )
              )}
            </>
          )}
        </>
        {!selectProducts ? (
          <HoverCardDetail
            title="Select Staff"
            description={
              <>
                <p className="mb-2 font-medium text-sm dark:text-white">Select multiple staff records in the current list for bulk actions.</p>
                <ul className="list-disc pl-5 text-sm dark:text-gray-300 space-y-1">
                  <li>Efficiently manage multiple records at once.</li>
                  <li>Ideal for bulk deletion, recovery, or updates.</li>
                  <li>Review your selection carefully before applying changes.</li>
                </ul>
              </>
            }
          >
            <label
              htmlFor=""
              className="hover:border-3 hover:scale-110 transition-all duration-300 font-semibold  rounded-full lg:w-10 lg:h-10 md:w-10 md:h-10 w-8 h-8 flex items-center justify-center cursor-pointer border border-gray-300 text-md"
            >
              <CircleStop
                onClick={() => {
                  setSelectProducts(true);
                  dispatch(setIndexs(""));
                }}
                className="text-sm"
              />
            </label>
          </HoverCardDetail>
        ) : (
          <>
            <HoverCardDetail
              title="Select All Staff "
              description={
                <>
                  <p className="mb-2 font-medium text-sm dark:text-white">Select all staff records in the current list for bulk actions.</p>
                  <ul className="list-disc pl-5 text-sm dark:text-gray-300 space-y-1">
                    <li>Efficiently manage multiple records at once.</li>
                    <li>Ideal for bulk deletion, recovery, or updates.</li>
                    <li>Review your selection carefully before applying changes.</li>
                  </ul>
                </>
              }
            >
              <label
                className={`group hover:border-blue-500 hover:border-3 hover:scale-110 transition-all duration-300 font-semibold rounded-full lg:w-10 lg:h-10 md:w-10 md:h-10 w-8 h-8 
                                                  flex items-center justify-center cursor-pointer border 
                                                  ${isAllSelected ? "border-blue-500 border-2" : "border-gray-300"} text-md`}
              >
                <CircleCheck
                  onClick={() => {
                    handleToggleSelectAll();
                  }}
                  className={` group-hover:text-white group-hover:bg-blue-500 ${
                    isAllSelected ? "bg-blue-500 text-white rounded-full" : " rounded-full"
                  } transition-colors duration-300`}
                />
              </label>
            </HoverCardDetail>
            <HoverCardDetail
              title="Select Staff"
              description={
                <>
                  <p className="mb-2 font-medium text-sm dark:text-white">Select multiple staff records in the current list for bulk actions.</p>
                  <ul className="list-disc pl-5 text-sm dark:text-gray-300 space-y-1">
                    <li>Efficiently manage multiple records at once.</li>
                    <li>Ideal for bulk deletion, recovery, or updates.</li>
                    <li>Review your selection carefully before applying changes.</li>
                  </ul>
                </>
              }
            >
              <label
                htmlFor=""
                className="hover:border-3 hover:scale-110 transition-all duration-300 font-semibold rounded-full lg:w-10 lg:h-10 md:w-10 md:h-10 w-8 h-8 flex items-center justify-center cursor-pointer border border-gray-300 text-md"
              >
                <CircleOff
                  onClick={() => {
                    setSelectedProductIds([]);
                    setSelectProducts(false);
                  }}
                  className="text-sm"
                />
              </label>
            </HoverCardDetail>
          </>
        )}
      </div>
      {loadingPrint ? (
        <label
          onClick={() => {
            handlePrint();
          }}
          htmlFor=""
          className="hover:border-3 hover:scale-110 transition-all  duration-300 ms-3 font-semibold rounded-full lg:w-10 lg:h-10 md:w-10 md:h-10 w-8 h-8 flex items-center justify-center cursor-pointer border border-gray-300 text-md"
        >
          <Loader className="animate-spin" />
        </label>
      ) : (
        <HoverCardDetail
          title="Daily Attendance Detail Report"
          description={
            <>
              <p className="mb-2 font-medium text-sm text-gray-800">View and analyze detailed attendance records for each employee on a daily basis.</p>
              <ul className="list-disc pl-5 text-sm text-gray-700 space-y-1">
                <li>Monitor clock-in/out times, absences, and late entries.</li>
                <li>Track working hours, overtime, and shift compliance.</li>
                <li>Export reports for HR reviews or payroll processing.</li>
                <li>Identify patterns for attendance-related issues.</li>
              </ul>
            </>
          }
        >
          <label
            onClick={() => {
              handlePrint();
            }}
            htmlFor=""
            className="hover:border-3 hover:scale-110 transition-all  duration-300 ms-3 font-semibold rounded-full lg:w-10 lg:h-10 md:w-10 md:h-10 w-8 h-8 flex items-center justify-center cursor-pointer border border-gray-300 text-md"
          >
            <PrinterCheck />
          </label>
        </HoverCardDetail>
      )}
      <div className="flex items-center gap-2 ms-5 ">
        <DatePicker
          className="py-4 h-[40px] w-[200px] border border-gray-300"
          onChange={(value: any) => {
            setDobStaff(value);
          }}
          value={dobStaff}
        />
      </div>

      <div className="flex items-center gap-2">
        <div className="flex-1 ms-4 me-2">
          <div className="relative">
            <SearchBarStaff
              onValueChange={(value) => {
                setSearchTextInput(value);
              }}
            />
          </div>
        </div>

        {/* View Toggle Button */}
        <HoverCardDetail
          title="Reset"
          description={
            <>
              <p className="mb-2 font-medium text-sm dark:text-white">Switch between different layouts to view staff records in the format you prefer.</p>
              <ul className="list-disc pl-5 text-sm dark:text-gray-300 space-y-1">
                <li>
                  <strong>Card View:</strong> Shows each staff as an individual card with profile info and actions.
                </li>
                <li>
                  <strong>Table View:</strong> Displays staff in a structured table for sorting, scanning, and bulk actions.
                </li>
                <li>Use the layout that best suits your workflow or screen size.</li>
              </ul>
            </>
          }
        >
          <div className="relative">
            {view === "card" ? (
              <button
                onClick={() => changeView("table")}
                className="font-semibold rounded-full lg:w-10 lg:h-10 md:w-10 md:h-10 w-8 h-8 flex items-center justify-center cursor-pointer border border-gray-300 text-md"
              >
                <Grid2x2 className="font-semibold size-5" />
              </button>
            ) : (
              <button
                onClick={() => changeView("card")}
                className="font-semibold rounded-full w-10 h-10 flex items-center justify-center cursor-pointer border border-gray-300 text-md"
              >
                {/* <WalletCards  /> */}
                <CreditCard className="text-xl" />
              </button>
            )}
          </div>
        </HoverCardDetail>
      </div>
    </nav>
  );
};

export default StaffNavbar;
